import 'vue-select/dist/vue-select.css';
import './v-calendar.css';
import 'nprogress/nprogress.css';

import Vue from 'vue';
import App from './App.vue';
import './icons';
import router from './router';
import store from './store';
import { UserGetters } from './Getters';
import AlertPlugin from './plugins/alert';
import VCalendar from 'v-calendar';
import { loadPaypalScripts } from './paypal';
import NProgress from 'vue-nprogress';

Vue.config.productionTip = false;

// Setup a navigation guard to not allow a user to move to locations if they are not authenticated
router.beforeEach((to, from, next) => {
  if (to.meta !== undefined && to.meta.isAuthenticated) {
    if (!store.getters[UserGetters.isAuthenticated]) return next(false);
    if (to.meta.role !== undefined) {
      if (Array.isArray(to.meta.role) && to.meta.role.indexOf(store.getters[UserGetters.getRole]) === -1) return next(false);
      if (typeof to.meta.role === 'string' && store.getters[UserGetters.getRole] !== to.meta.role) return next(false);
    }
  } else if (to.meta !== undefined && to.meta.isAuthenticated === false && store.getters[UserGetters.isAuthenticated]) {
    return next(false);
  }
  next();
});

Vue.use(AlertPlugin);
Vue.use(VCalendar);
Vue.use(NProgress);

loadPaypalScripts();

const nprogress = new NProgress()

new Vue({
  router,
  store,
  nprogress,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
}).$mount('#app');
